import { useAttendantData } from '@/zustand/useAttendantData';

export const addAttendantAuthorizationHeader = (init) => {
  const { token } = useAttendantData.getState();

  if (token) {
    const bearerToken = `Bearer ${token}`;
    init.headers = {
      ...init.headers,
      'attendant-authorization': bearerToken
    };
  }
  return init;
};
